<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<wcg-profile-card [size]="cardSize()">
  <ng-container wcgProfileCardHeader>
    <h2
      data-testid="designation__title"
      class="profile__designation-title flex flex-row items-center gap-4"
    >
      <mat-icon
        data-testid="designation__icon"
        fontSet="material-icons-outlined"
        class="!text-blue-11"
      >
        {{ icon() }}
      </mat-icon>
      {{ title() }}
    </h2>
  </ng-container>

  <ng-container wcgProfileCardContent>
    <div class="w-full flex flex-col gap-2 p-6">
      @if (!loading() && designationType() === "degrees") {
        <div
          data-testid="designation__label"
          class="profile__designation-label"
        >
          {{ label() }}
        </div>
      }
      <div
        data-testid="designation__content"
        class="w-full flex flex-row gap-4 py-6 items-center"
      >
        <wcg-inline-editor
          class="w-full"
          data-testid="designation__inline-editor"
          [turnoffInlineEdit]="false"
          [defaultView]="editMode() ? 'Edit' : 'View'"
        >
          <ng-template wcgInlineViewMode>
            @if ($designations() && $designations().length > 0) {
              <div
                data-testid="designation__chip-grid"
                class="profile__designation-chip-grid flex flex-row items-center"
                cdkDropList
                cdkDropListOrientation="mixed"
                (cdkDropListDropped)="handleChipDrop($event)"
                (click)="enterEditMode()"
              >
                @for (designation of $designations(); track designation.id) {
                  <div
                    class="profile__designation-chip-drag-item"
                    cdkDrag
                    [cdkDragData]="designation"
                    [cdkDragDisabled]="!canEdit()"
                  >
                    <mat-chip
                      data-testid="designation__chip"
                      [removable]="canEdit()"
                      disableRipple
                    >
                      <span
                        data-testid="designation__chip-label"
                        class="profile__designation-chip-label"
                      >
                        {{ designation.label }}
                      </span>
                      @if (canEdit()) {
                        <button
                          data-testid="designation__remove-button"
                          matChipRemove
                          (click)="removeDesignation(designation, $event)"
                        >
                          <mat-icon>cancel</mat-icon>
                        </button>
                      }
                    </mat-chip>
                    <div
                      class="profile__designation-chip-placeholder"
                      *cdkDragPlaceholder
                    ></div>
                  </div>
                }
                @if (canEdit()) {
                  <p
                    class="designation__label"
                    data-testid="designation__add-button"
                    (click)="enterEditMode()"
                  >
                    Add..
                  </p>
                }
              </div>
            } @else {
              <span
                data-testid="designation__no-value"
                class="profile__designation-no-value"
                (click)="enterEditMode()"
              >
                {{
                  ` No ${title()} were assigned. ${canEdit() ? "click to add..." : ""}`
                }}
              </span>
            }
          </ng-template>
          
          <ng-template wcgInlineEditMode>
            <wcg-chip-selector
              [chipFormArray]="$designations()"
              [options]="options()"
              (selectedChips)="handleSelectedChips($event)"
            />
          </ng-template>
        </wcg-inline-editor>
      </div>
    </div>
  </ng-container>
</wcg-profile-card>
